<template>
  <div class="slider">
    <loader v-if="loading"/>
    <carousel
      v-else
      :paginationEnabled="false"
      :perPage="1"
    >
      <slide
        v-for="(slide, index) in slides"
        :key="`news-slide-${slide.id}-${index}`"
      >
        <div class="slide">
          <figure class="slide-picture">
            <img
              v-if="slide.picture && slide.picture.src"
              :src="slide.picture.src"
              :srcset="slide.picture.src2x ? `${slide.picture.src2x} 2x` : null"
              :alt="slide.picture.alt"
            >
            <img
              v-else
              src="@/assets/images/event-default.jpg"
              :alt="slide.title"
            >
            <span
              v-if="slide.isTicket"
              class="slide-picture-label label"
            >
              Votre prochain {{ slide.stream ? 'streaming' : 'spectacle' }}
            </span>
          </figure>
          <div class="slide-content">
            <h3
              class="slide-title"
              v-html="slide.title"
            />
            <span class="slide-date">{{ slide.isEvent || slide.isTicket ? slide.date : `Publié le ${slide.date}` }}</span>
            <span class="slide-pseudo-link">
              {{ slide.isTicket ? 'Accéder à mes billets' : 'En savoir plus' }}
              <sprite
                :type="'chevron-right'"
                :width="5"
                :height="8"
              />
            </span>
          </div>

          <button
            v-if="slide.isEvent"
            class="slide-like"
            type="button"
            @click.prevent="onLike(slide)"
          >
            <span class="u-visually-hidden">J'aime</span>
            <sprite
              :type="'heart-bordered'"
              :width="24"
              :height="21"
            />
          </button>

          <!--  Link -->
          <router-link
            :to="getTo(slide)"
            class="slide-link"
          >
            <span class="u-visually-hidden">{{ slide.title }}</span>
          </router-link>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import Sprite from '@/components/components/Sprite.vue';
import Loader from '@/components/components/Loader.vue';

export default {
  components: {
    Carousel,
    Slide,
    Sprite,
    Loader
  },
  props: {
    slides: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getTo(slide) {
      if (slide.isTicket) {
        return '/orders';
      }

      if (slide.isEvent) {
        return `/events/${slide.id}`;
      }

      return `/news/${slide.slug}`;
    },
    onLike(slide) {
      this.$store.dispatch('profile/like', {
        event: slide.id,
        user: this.$store.state.login.logged ? this.$store.state.profile.infos.id : null,
        update: 'events',
        eventFull: slide
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.slider {
  width: calc(100% - 20px);

  .slide {
    @include size(100%);
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: $black-light;
    width: 100%;

    &-picture {
      @include aspect-ratio(294, 115);
      width: 100%;

      img {
        @include position(absolute, 0 null null 0);
        @include size(100%);
        object-fit: cover;
      }

      &-label {
        @include position(absolute, 16px null null 16px);
      }
    }

    &-content {
      @include padding(24px, 16px);
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex-grow: 1;
      width: 100%;
    }

    &-title {
      @include line-clamp(2, 27px, false);
      font-size: rem(24px);
      font-weight: 700;
      line-height: (27 / 24);
    }

    &-date {
      @include margin(8px null 16px);
      font-size: rem(16px);
      line-height: (19 / 16);
    }

    &-pseudo-link {
      @include font('secondary', 'regular');
      @include margin(auto null null);
      color: $primary;
      font-size: rem(16px);
      line-height: (19 / 16);

      .svg {
        margin-left: 3px;
        fill: $primary;
      }
    }

    &-like {
      @include position(absolute, 5px 9px null null);
      @include padding(10px);
      outline: none;
      z-index: 2;

      .svg {
        position: relative;
        z-index: 1;
        fill: $primary;
        stroke: $primary;
      }
    }

    &-link {
      @include position(absolute, 0 null null 0);
      @include size(100%);
      z-index: 1;
    }
  }
}
</style>

<style lang="scss">
.slider {
  .VueCarousel-wrapper {
    overflow: visible;
  }

  .VueCarousel-slide {
    padding-right: 20px;
  }
}
</style>
